export enum EAdminPages {
    Users = 'Manage users',
    Config = 'Configuration'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/admin.ts